// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input.disabled[data-v-0add30a8],input:active.disabled[data-v-0add30a8],input:focus.disabled[data-v-0add30a8],input:hover.disabled[data-v-0add30a8]{--tw-bg-opacity:1;background-color:rgba(209,213,219,var(--tw-bg-opacity))}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,mJAAA,iBAAA,CAAA,uDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
